import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';


@Component({
  selector: 'page-perakende-fatura-detay',
  templateUrl: 'perakende-fatura-detay.html',
})
export class PerakendeFaturaDetayPage {
  vWFatura: any = { ID: "" };
  vwFatura2:any={ID:"",IslemCode:""};
  vwFatura3:any={ID:"",BelgeNo:""}
  detayListesi = [];
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
     
    if (navParams.get("vWFatura") != null) {
      if(navParams.get("vWFatura") != "")
      {
    
      this.vWFatura = navParams.get("vWFatura");
      var formdata = new FormData();
      formdata.append("faturaid", this.vWFatura.ID);
      this.bllOrtak.islem(formdata, "PerakendeSatisDetaylari", "", true).then(a => {
        var sonuc = <any>a;
        this.detayListesi = sonuc.SonucObject;
      });
    }
    }
    if (navParams.get("vwFatura2") != null) {
      this.vwFatura2 = navParams.get("vwFatura2");
      
      var formdata = new FormData();
      
      formdata.append("islemcode", this.vwFatura2.BelgeNo);
     
 
      this.bllOrtak.islem(formdata, "PerakendeSatisDetaylari2", "", false).then(a => {
        var sonuc = <any>a;
        this.detayListesi = sonuc.SonucObject;
        console.log("sonuc", sonuc);
      });
    }
    if (navParams.get("vwFatura3") != null) {
      this.vwFatura3 = navParams.get("vwFatura3");
     
      var formdata = new FormData();
      formdata.append("islemcode", this.vwFatura3.BelgeNo);
 
      this.bllOrtak.islem(formdata, "PerakendeSatisDetaylari2", "", true).then(a => {
        var sonuc = <any>a;
        this.detayListesi = sonuc.SonucObject;
      });
    }
    if (navParams.get("vcarihar") != null) {
      this.vwFatura3 = navParams.get("vcarihar");
    
      var formdata = new FormData();
      formdata.append("islemcode", this.vwFatura3.IslemCode);
      this.bllOrtak.islem(formdata, "PerakendeSatisDetaylari2", "", true).then(a => {
        var sonuc = <any>a;
        this.detayListesi = sonuc.SonucObject;
      });
    }
  }
  kapat()
  {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/perakende-fatura-detay/perakende-fatura-detay.ts